import { render } from "./MenuTabGroupButton.vue?vue&type=template&id=19cfc972"
import script from "./MenuTabGroupButton.vue?vue&type=script&lang=js"
export * from "./MenuTabGroupButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__